import { appActions as A } from "./reducer";
import { pushLiveTicket } from '../tickets/actions';
import { runLiveTicketTest } from '../../test/live_ticket';
import store2 from "store2";

/** Actions */
export const toggleDebug = (dispatch, getState) => {
    let debug = !getState().app.debug;

    if(debug) {
        window.state = getState;
        window.pushLiveTicket = (ticket) => dispatch(pushLiveTicket(ticket))
        window.runLiveTicketTest = runLiveTicketTest
        window.store = store2;
    } else {
        delete window.state;
        delete window.pushLiveTicket;
    }

    dispatch(_toggleDebug());
}

/** Dispatchers */
function _toggleDebug() {
    return {
        type: A.toggle_debug
    }
}